// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const SmokeEntityOption = (props) => {
    
    const [particleList, setParticleList] = useState([]);
    const [indexNum, setIndexNum] = useState("");

    useEffect(() => {
        setParticleList(props.particleList);
        setIndexNum(props.indexNum);
    }, [props])

    let field = particleList[indexNum];

    if (field) {
        return (
            <Dialog header="煙霧粒子參數設定"  visible={props.SmokeEntity} style={{ width: '25%' }} position={'right'} modal={false} keepInViewport={false} onHide={() => props.onHide('SmokeEntity')}>
                <Card>
                    <Card>
                        <h5>煙霧生成設定</h5>
                        <Divider />
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">煙霧生成頻率(Hz) :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityRate} onChange={(e) => props.setEntityRate(e.target.value)} placeholder={field.param.rate} style={{ width: "100%" }}/>
                            </div>
                        </div>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">煙霧大小 :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entitySize} onChange={(e) => props.setEntitySize(e.target.value)} placeholder={field.param.size} style={{ width: "100%" }} />
                            </div>
                        </div>

                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">煙霧壽命(sec) :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityLife} onChange={(e) => props.setEntityLife(e.target.value)} placeholder={field.param.life} style={{ width: "100%" }}/>
                            </div>
                        </div>

                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">煙霧上飄最慢速度(m/s) :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityMinSpeed} onChange={(e) => props.setEntityMinSpeed(e.target.value)} placeholder={field.param.minSpeed} style={{ width: "100%" }}/>
                            </div>
                        </div>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">煙霧上飄最快速度(m/s) :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityMaxSpeed} onChange={(e) => props.setEntityMaxSpeed(e.target.value)} placeholder={field.param.maxSpeed} style={{ width: "100%" }}/>
                            </div>
                        </div>
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-5 md:mb-0">重力(m/s^2) :</label>
                            <div className="col-12 md:col-7">
                                <InputText value={props.entityGravity} onChange={(e) => props.setEntityGravity(e.target.value)} placeholder={field.param.gravity} style={{ width: "100%" }}/>
                            </div>
                        </div>
                    </Card>
                    <br></br>
                    <Card>
                        <h5>煙霧顏色設定</h5>
                        <Divider />
                        <div className="field grid">
                            <label className="col-12 mb-4 md:col-2 md:mb-0">權重R :</label>
                            <div className="col-12 md:col-2">
                                <InputText value={props.entityRGBWeightR} onChange={(e) => props.setEntityRGBWeightR(e.target.value)} placeholder={field.param.rgbWeight[0]} style={{ width: "100%" }}/>
                            </div>

                            <label className="col-12 mb-4 md:col-2 md:mb-0">權重G :</label>
                            <div className="col-12 md:col-2">
                                <InputText value={props.entityRGBWeightG} onChange={(e) => props.setEntityRGBWeightG(e.target.value)} placeholder={field.param.rgbWeight[1]} style={{ width: "100%" }}/>
                            </div>

                            <label className="col-12 mb-4 md:col-2 md:mb-0">權重B :</label>
                            <div className="col-12 md:col-2">
                                <InputText value={props.entityRGBWeightB} onChange={(e) => props.setEntityRGBWeightB(e.target.value)} placeholder={field.param.rgbWeight[2]} style={{ width: "100%" }}/>
                            </div>
                        </div>
                    </Card>
                    <Divider />
                    <div className="field grid">
                        <div className="col-12 md:col-6">
                            <Button label="確定變更" icon="pi pi-check" className="p-button-raised p-button-info " onClick={() => { props.changeSmog(indexNum) }} style={{ width: "100%" }} />
                        </div>
                        <div className="col-12 md:col-6">
                            <Button label="捨棄變更" icon="pi pi-trash" className="p-button-raised p-button-danger " onClick={() => { props.setReChange(true) }} style={{ width: "100%" }} />
                        </div>
                    </div>
                </Card>
            </Dialog>
        )
    } else {
        return null;
    }
}